import { DEV_HOST, HOST, DEV_SERVER_HOST } from "main/constants/constant";

export function getServersideUrl(locale: string): string {
  // dev
  if (!process.env.APP_ENV || process.env.APP_ENV === "development") {
    return DEV_SERVER_HOST[locale];
  } else {
    return HOST[locale];
  }
}

export function getBrowserUrl(locale: string): string {
  // dev
  if (!process.env.APP_ENV || process.env.APP_ENV === "development") {
    return DEV_HOST[locale];
  } else {
    return HOST[locale];
  }
}

export function getBrowserHost(locale: string): string {
  const url = getBrowserUrl(locale);
  return url.replace(/http(s)?:\/\//, "");
}

export function getServersideHost(locale: string): string {
  const url = getServersideUrl(locale);
  return url.replace(/http(s)?:\/\//, "");
}
